export class OwnerDTO {
    public readonly id: number;
    public readonly last_name: string;
    public readonly first_name: string;
    public readonly role?: string;
    public readonly email?: string;
    public readonly phone?: string;

    constructor(data: {
        id: number;
        last_name: string;
        first_name: string;
        role?: string;
        email?: string;
        phone?: string;
    }) {
        this.id = data.id;
        this.last_name = data.last_name;
        this.first_name = data.first_name;
        this.role = data.role;
        this.email = data.email;
        this.phone = data.phone;
    }

    public static fromRaw(raw: Record<string, any>): OwnerDTO {
        return new OwnerDTO({
            id: Number(raw.id),
            last_name: String(raw.last_name ?? ""),
            first_name: String(raw.first_name ?? ""),
            role: raw.role != null ? String(raw.role) : undefined,
            email: raw.email != null ? String(raw.email) : undefined,
            phone: raw.phone != null ? String(raw.phone) : undefined,
        });
    }

    public static fromArray(
        users: Array<{
            id: number;
            last_name?: string | null;
            first_name?: string | null;
            role?: string;
            roles?: Array<{ slug: string }>;
            email?: string | null;
            phone?: string | null;
        }>
    ): OwnerDTO[] {
        return users.map((user) => {
            const roleSlug = 
                user.role || 
                (Array.isArray(user.roles) && user.roles.length > 0 && user.roles[0]?.slug) || 
                undefined;

            return new OwnerDTO({
                id: user.id,
                last_name: user.last_name ?? '',
                first_name: user.first_name ?? '',
                role: roleSlug,
                email: user.email || undefined,
                phone: user.phone || undefined,
            });
        });
    }

    public toJSON(): {
        id: number;
        last_name: string;
        first_name: string;
        role?: string;
        email?: string;
        phone?: string;
    } {
        return {
            id: this.id,
            last_name: this.last_name,
            first_name: this.first_name,
            role: this.role,
            email: this.email,
            phone: this.phone,
        };
    }
}